import { GroupUser } from '@shared/api/types';
import Text from '@shared/components/content/text';
import { DateCell } from '@shared/components/data-table/cells/date-cell';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { ColumnDef } from '@tanstack/react-table';

// The group users endpoint paginates server-side but doesn't support ordering,
// so columns are not sortable; the name column stays filterable to drive the
// "Search users…" box in the toolbar.
export function useGroupUsersColumns(): ColumnDef<GroupUser>[] {
  return [
    {
      id: 'name',
      accessorKey: 'name',
      enableSorting: false,
      enableColumnFilter: true,
      header: ({ column }) => <HeaderCell column={column} name="Name" />,
      cell: ({ getValue }) => <Text>{getValue<string>()}</Text>,
      meta: {
        label: 'Name',
        variant: 'text',
        placeholder: 'Search users…',
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
    {
      id: 'email',
      accessorKey: 'email',
      enableSorting: false,
      header: ({ column }) => <HeaderCell column={column} name="Email" />,
      cell: ({ getValue }) => (
        <Text variant="subtle">{getValue<string>()}</Text>
      ),
    },
    {
      id: 'lastLogin',
      accessorKey: 'lastLogin',
      enableSorting: false,
      header: ({ column }) => <HeaderCell column={column} name="Last login" />,
      cell: ({ getValue }) => {
        const lastLogin = getValue<string | null>();
        if (!lastLogin) return <Text variant="subtle">Never</Text>;
        return <DateCell date={lastLogin} />;
      },
    },
  ];
}
